import React, { useState, useRef } from 'react'
import {
	Box,
	Flex,
	Grid,
	GridItem,
	Heading,
	Stack,
	Text,
	Spinner,
	Center,
	Table,
	Thead,
	Tr,
	Th,
	Tbody,
	Td,
	Image,
	SimpleGrid,
	VStack,
	HStack,
	Alert,
	AlertDialog,
	AlertDialogBody,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogContent,
	AlertDialogOverlay,
	useToast,
	Button,
	Icon
} from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import AdminBlockCard from '../../components/AdminBlockCard'
import AdminBusinessCard from '../../components/AdminBusinessCard'
import AdminStatsCard from '../../components/AdminStatsCard'
import { BsArrowRight } from 'react-icons/bs'
import 'react-phone-number-input/style.css'
import { getRequest } from '../../services/base.service'
import { useDispatch } from 'react-redux'
import {
	setAdminSidebarFalseOnUrlChange,
	setCurrentPageHeading,
} from '../../redux/common/commonActions'
import { FiEye, FiEdit2, FiArrowRight } from 'react-icons/fi'
import { MdDeleteForever } from "react-icons/md";
import { deleteRequest } from '../../services/base.service'
import { GoPlus, GoArrowRight } from 'react-icons/go'
import { useNavigate } from 'react-router-dom'

const AdminDashboard = () => {
	const [dashboardData, setDashboardData] = useState({
		signup_today: 0,
		pending_approval: 0,
		pending_claim: 0,
	})
	const [businessList, setBusinessList] = useState([])
	const [spinner, setSpinner] = useState({ status: true })
	const [deleteableBusinessId, setDeleteableBusinessId] = useState(null)
	const [alertDialogIsOpen, setAlertDialogIsOpen] = useState(false)
	const dispatch = useDispatch()
	const toast = useToast()
	const navigate = useNavigate()

	React.useEffect(() => {
		dispatch(setCurrentPageHeading('Dashboard'))
		dispatch(setAdminSidebarFalseOnUrlChange())
		getRequest('admin/dashboard')
			.then((res) => {
				setDashboardData(res.result)
			})
			.then((data) => {})
		getRequest('admin/businesses', { params: { status: 'pending', limit: 10 } })
			.then((res) => {
				setBusinessList(res.result?.data)
				setSpinner({ status: false })
			})
			.then((data) => {})
	}, [dispatch])

	const CardAction = () => (
		<Box color={'red.500'}>
			<Text as={Link} to="/admin/business-list" fontSize={'sm'}>
				<Flex align={'center'}>
					View All
					<BsArrowRight />
				</Flex>
			</Text>
		</Box>
	)

	// const deleteBusiness = (businessId) => {
	// 	setDeleteableBusinessId(businessId)
	// 	setAlertDialogIsOpen(true)
	// }
	const hideConfirmDialog = () => {
		setDeleteableBusinessId(null)
		setAlertDialogIsOpen(false)
	}
	const formatDate = (dateString) => {
			const date = new Date(dateString);
			return date.toLocaleDateString('en-GB'); 
	};
	const cancelRef = useRef()
	// const handleBusinessDeleteConfirm = () => {
	// 		deleteRequest(`admin/business/${deleteableBusinessId}`)
	// 			.then((res) => {
					
	// 				hideConfirmDialog()
	// 				toast({
	// 					title: 'Status Changed.',
	// 					description: res.message,
	// 					status: 'success',
	// 					duration: 5000,
	// 					isClosable: true,
	// 				})
	// 				setCurrentPage(1)
	// 				fetchBusinessList({ ...queryParams, page: 1 })

	// 			})
	// 			.catch((error) => {
	// 				toast({
	// 					title: 'Error',
	// 					description: error.response.data.message || 'Something went wrong',
	// 					status: 'error',
	// 					duration: 5000,
	// 					isClosable: true,
	// 				})
					
	// 			})
	// }

	return (
		<Box py={'7'}>
			<AlertDialog
				isOpen={alertDialogIsOpen}
				leastDestructiveRef={cancelRef}
				onClose={hideConfirmDialog}
			>
									<AlertDialogOverlay>
										<AlertDialogContent>
											<AlertDialogHeader fontSize="lg" fontWeight="bold">
												Confirmation
											</AlertDialogHeader>
				
											<AlertDialogBody>
												Are you sure? You can't undo this action afterwards.
											</AlertDialogBody>
				
											<AlertDialogFooter>
												<Button ref={cancelRef} onClick={hideConfirmDialog}>
													Cancel
												</Button>
												<Button
													colorScheme={'red'}
													// onClick={() => handleBusinessDeleteConfirm()}
													ml={3}
												>
													Confirm
												</Button>
											</AlertDialogFooter>
										</AlertDialogContent>
									</AlertDialogOverlay>
								</AlertDialog>
			<Heading fontSize="xl">Quick Stats</Heading>

			<Grid
				templateColumns={[
					'repeat(1, 1fr)',
					'repeat(3, 1fr)',
					'repeat(2, 1fr)',
					'repeat(3, 1fr)',
				]}
				gap={4}
				mt={2}
			>
				<GridItem w="100%">
					<AdminStatsCard
						title={'Sign Ups Today'}
						value={dashboardData?.signup_today}
						mb={'10'}
					/>
				</GridItem>
				<GridItem>
					<AdminStatsCard
						title={'Pending Approvals'}
						value={dashboardData?.pending_approval}
						mb={'10'}
					/>
				</GridItem>
				<GridItem>
					<AdminStatsCard
						title={'Pending Claims'}
						value={dashboardData?.pending_claim}
						mb={'10'}
					/>
				</GridItem>
			</Grid>

			<Box mt="10">
				<AdminBlockCard title={'Pending Requests'} actions={<CardAction />}>
					{spinner.status && (
						<Center>
							<Spinner color="red.500" size="xl" speed="0.6s" />
						</Center>
					)}
					{businessList.length > 0 ? (
						<>
							<Stack gap={2} rounded={'md'} overflow={'auto'} border={'1px'} borderColor="gray.200" marginTop={5}>
								{/* {businessList?.map((business, index) => (
									<AdminBusinessCard
										key={index}
										companyName={business?.name}
										data={business}
									/>
								))} */}
									<Table
										variant="simple"
										w={'100%'}
									>
										<Thead bg="gray.100">
											<Tr>
												<Th>Logo</Th>
												<Th>Id</Th>
												<Th>Name</Th>
												<Th>Address</Th>
												<Th>Created</Th>
												<Th> Last Updated</Th>
												<Th>Status</Th>
												<Th textAlign="right">Actions</Th>
											</Tr>
										</Thead>
										<Tbody>
											{businessList.map((business, index) => (
												<Tr key={business.id} bg={index % 2 === 0 ? 'gray.50' : 'white'}>
													<Td>
														<Image
															src={business.logo}
															alt={business.name}
															boxSize="50px"
															objectFit="contain"
														/>
													</Td>
													<Td>{business.id}</Td>
													<Td>{business.name}</Td>
													<Td>{business.address1}</Td>
													<Td>{formatDate(business.created_at)}</Td>
													<Td>{formatDate(business.updated_at)}</Td>
													<Td>{business.status}</Td>
													<Td key={business.id}>
														<HStack
															textAlign="right"
															align="right"
															justify="right"
															gap={2}
														>
															<Link to={`/admin/business-list/details/${business.id}`}>
																<FiEye cursor="pointer" />
															</Link>
															<Link to={`/admin/business/edit/${business?.id}`}>
																<FiEdit2 cursor="pointer" />
															</Link>														
														</HStack>
													</Td>												
												</Tr>
											))}
										</Tbody>									
									</Table>								
							</Stack>
							<Flex justifyContent="flex-end" mt={2}>
								<Button
									variant={'brand'}
									size={'sm'}
									onClick={() => navigate('/admin/business-list')}
									mt={4} 
								>
									Go to Business List
									<Icon as={FiArrowRight} ml={2} />
								</Button>
							</Flex>
						</>
					) : (
						<Alert status="error">
							<Center h={'100%'} w={'100%'}>
								NO DATA FOUND.
							</Center>
						</Alert>
					)}
				</AdminBlockCard>
			</Box>
		</Box>
	)
}

export default AdminDashboard
